import React from 'react';

export default function ModeFull() {
  return (
    <svg width="86" height="40" viewBox="0 0 86 40" style={{ fill: '#37B067' }}>
      <polygon points="47.07 26 47.07 13.98 44.2 13.98 41.01 19.06 37.82 13.98 34.94 13.98 34.94 26 37.56 26 37.56 18.2 40.02 21.91 41.92 21.91 44.42 18.15 44.42 26 47.07 26" />
      <path d="M59,20v0a3.67,3.67,0,0,0-3.67-3.78A3.62,3.62,0,0,0,51.64,20v0a3.67,3.67,0,0,0,3.67,3.78A3.62,3.62,0,0,0,59,20m-10.1,0v0a6.45,6.45,0,0,1,12.89,0v0a6.45,6.45,0,0,1-12.89,0" />
      <path d="M68.25,23.61A3.44,3.44,0,0,0,71.9,20v0a3.46,3.46,0,0,0-3.65-3.62H66.18v7.24ZM63.52,14h4.73c3.81,0,6.44,2.59,6.44,6v0c0,3.38-2.63,6-6.44,6H63.52Z" />
      <polygon points="76.77 13.98 76.77 26 86 26 86 23.65 79.42 23.65 79.42 21.12 85.13 21.12 85.13 18.77 79.42 18.77 79.42 16.33 85.91 16.33 85.91 13.98 76.77 13.98" />
      <polygon points="27.96 8 13.98 16 0 8 0 32 6.99 28 6.99 20 13.98 24 20.97 20 20.97 28 27.96 32 27.96 8" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/ModeFull/index.js